import { render } from "./settings.vue?vue&type=template&id=4b13ea2c"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=4b13ea2c&lang=css"
script.render = render

export default script